/* eslint-disable no-unused-expressions */
import { getCookie, cookies } from '../utils/common/cookies';
import { getClaimLossCause, getClaimSecLossCause } from '../utils/constants/typeClaimMapping';

export function sendEventData(event, claimData, claimStatus) {
  const finalObject = {};

  claimStatus && (finalObject.claim_status = claimStatus);

  finalObject.timeout = boolToString(event === 'sessionTimeout');

  const timeoutStorage = parseInt(window.sessionStorage.getItem('timeout'), 10);
  !timeoutStorage && (finalObject.timeout = 'No');

  const claimSupportId = getCookie(cookies.claimSupportId);
  claimSupportId && (finalObject.claim_support_id = claimSupportId);

  const supportId = getCookie(cookies.fullStorySupportId);
  supportId && (finalObject.fullstory_support_id = supportId);

  const userIP = window.sessionStorage.getItem('userIP');
  userIP && (finalObject.user_ip = userIP);

  const googlePID = window.dataLayer?.filter((data) => data.PID)?.PID;
  googlePID && (finalObject.goolgePID = googlePID);

  const policyDetails = JSON.parse(window.sessionStorage.getItem('thePolicy'));
  policyDetails?.policyNumber && (finalObject.policy_number = policyDetails?.policyNumber);

  policyDetails?.insured?.firstName && (finalObject.first_name = maskData(null, 1, policyDetails?.insured?.firstName));

  policyDetails?.insured?.lastName && (finalObject.last_name = maskData(null, 1, policyDetails?.insured?.lastName));

  policyDetails?.insured?.email && (finalObject.email = maskData(3, 5, policyDetails?.insured?.email));

  policyDetails?.insured?.phone && (finalObject.phone_number = maskData(null, 3, policyDetails?.insured?.phone));

  const lossDate = claimData?.lossDate?.value;
  lossDate && (finalObject.loss_date = lossDate);

  const typeOfClaim = claimData?.claim_type?.claim_type;
  typeOfClaim && (finalObject.claim_type = typeOfClaim);

  const vehicleMake = claimData?.claim_type?.vehicle?.make;
  vehicleMake && (finalObject.vehicle_make = vehicleMake);

  const vehicleModel = claimData?.claim_type?.vehicle?.model;
  vehicleModel && (finalObject.vehicle_model = vehicleModel);

  const vehicleYear = claimData?.claim_type?.vehicle?.year;
  vehicleYear && (finalObject.vehicle_year = vehicleYear);

  if (claimData?.services) {
    finalObject.service_uber = boolToString(!!claimData?.services?.uber);
    finalObject.service_enterprise = boolToString(!!claimData?.services?.enterprise);
    finalObject.service_audatarget_vendor = boolToString(!!claimData?.services?.audatarget);

    finalObject.cerf_selected = boolToString(!!claimData?.services?.audatarget?.vendorLocation);

    const repairShop = claimData?.services?.audatarget?.vendorLocation?.name;
    repairShop && (finalObject.repair_shop = repairShop);
  }

  let nested;
  if (typeOfClaim === 'Vehicle' && claimData.claim_type.vehicle?.policySystemId === 'injuryOnly') {
    nested = { ...claimData.abonly?.data };
  } else if (typeOfClaim === 'Vehicle') {
    nested = { ...claimData.auto?.data };
  } else if (typeOfClaim === 'Home') {
    nested = { ...claimData.property?.data };
  }

  if (nested && Object.keys(nested).length) {
    const lossType = nested.lossCause?.value;
    lossType && (finalObject.loss_type = getClaimLossCause[lossType]);

    if (typeOfClaim === 'Vehicle' || claimData.claim_type?.vehicle?.policySystemId === 'injuryOnly') {
      const secLossCauseKey = Object.keys(nested).find((key) => key.startsWith('secLossCause_'));
      const secLossCause = nested[secLossCauseKey]?.value;
      secLossCause && (finalObject.secondary_loss_cause = getClaimSecLossCause[secLossCause]);

      const lossLocation = nested.lossLocationAddress?.value;
      lossLocation && (finalObject.loss_location = lossLocation);

      const province = nested.lossLocationAddress?.province;
      province && (finalObject.province = province);

      const postalCode = nested.lossLocationAddress?.postalCode;
      postalCode && (finalObject.postalCode = postalCode);

      const vehicleTowed = boolToString(nested.vehicleTowed?.value);
      vehicleTowed && (finalObject.vehicle_towed = vehicleTowed);

      const wasVehicleHitAndRun = boolToString(nested.wasVehicleHitAndRun?.value);
      wasVehicleHitAndRun && (finalObject.vehicle_towed = wasVehicleHitAndRun);

      const weatherRelated = boolToString(lossType === 'weather_events');
      weatherRelated && (finalObject.weather_related = weatherRelated);

      const multiVehicle = boolToString(lossType === 'multi_vehicle');
      multiVehicle && (finalObject.multi_vehicle = multiVehicle);

      const descriptionLoss = nested?.pleaseTellUsWhatHappened?.value;
      descriptionLoss && (finalObject.description_loss = descriptionLoss);

      const finalNotes = nested?.shareAdditionalDetails?.value;
      finalNotes && (finalObject.notes = finalNotes);

      const policeAuthoritiesNotified = boolToString(nested.reportedPolice?.value);
      policeAuthoritiesNotified && (finalObject.police_authorities_notified = policeAuthoritiesNotified);

      const policeReport = boolToString(nested?.file_policeReport?.uploadedDocuments?.length > 0);
      policeReport && policeAuthoritiesNotified && (finalObject.police_report = policeReport);

      const policeNameDetachment = nested?.police?.police1?.department?.value;
      policeNameDetachment && (finalObject.police_name_detachment = policeNameDetachment);

      const policeReportNumber = nested?.police?.police1?.reportNumber?.value;
      policeReportNumber && (finalObject.police_report_number = policeReportNumber);

      const fireNameDetachment = nested?.fire?.fire1?.department?.value;
      fireNameDetachment && (finalObject.fire_name_detachment = fireNameDetachment);

      const fireReportNumber = nested?.fire?.fire1?.reportNumber?.value;
      fireReportNumber && (finalObject.fire_report_number = fireReportNumber);

      const animalTypeHit = nested?.animalTypeHit?.value;
      animalTypeHit && (finalObject.animal_type_hit = animalTypeHit);

      const animalOwnerIdentified = boolToString(nested?.ownerContactInformation?.value);
      animalOwnerIdentified && (finalObject.animal_owner_identified = animalOwnerIdentified);

      const currentVehicleLocation = nested?.vehicleCurrentLocation?.value;
      currentVehicleLocation && (finalObject.vehicle_current_location = currentVehicleLocation);

      const airbagsDeployed = boolToString(nested?.airbagsDeploy?.value);
      airbagsDeployed && (finalObject.airbags_deploy = airbagsDeployed);

      const vehicleSafelyDriven = boolToString(nested?.vehicleSafelyDriven?.value);
      vehicleSafelyDriven && (finalObject.vehicle_safely_driven = vehicleSafelyDriven);

      const VehicleMechanicallyOperable = boolToString(nested?.vehicleStartDrive?.value);
      VehicleMechanicallyOperable && (finalObject.vehicle_mechanically_operable = VehicleMechanicallyOperable);

      const odometerReading = nested?.odometerReading?.value;
      odometerReading && (finalObject.odometer_reading = odometerReading);

      const injuryDescription = nested?.injuredInjuries?.whatAreTheInjuriesInfo[0]?.selectAllInjuriesApply?.selectedValues;
      injuryDescription?.length > 0 && (finalObject.injury_description = injuryDescription.join(', '));

      const exteriorItemsDamaged = nested?.injuredInjuries?.whatAreTheInjuriesInfo[0]?.wereAnyOfTheFollowingItemsDamaged?.selectedValues;
      exteriorItemsDamaged?.length > 0 && (finalObject.exterior_items_damaged = exteriorItemsDamaged.join(', '));

      const randomEvent = nested?.secLossCause_random?.value;
      randomEvent && (finalObject.random_event = randomEvent);

      const ownerContactInformation = nested?.ownerContactInformation;
      ownerContactInformation && (finalObject.pet_owner_information = `${nested?.owner?.firstName?.value} ${nested?.owner?.lastName?.value} ${nested?.owner?.phoneNumber?.value}`);

      const driverInjured = boolToString(nested?.driverIsInjured?.value);
      driverInjured && (finalObject.driver_injured = driverInjured);

      const audaTargetMask = nested?.vehicleIncident?.vehicleDamagesPanel?.value?.parts;
      audaTargetMask?.length > 0 && (finalObject.auda_target_mask = audaTargetMask.map((item) => item.id).join(', '));

      const isVehicleFound = boolToString(nested?.wasVehicleFound?.value);
      isVehicleFound && (finalObject.is_vehicle_found = isVehicleFound);

      const vehicleLicensePlate = nested?.vehicleLicensePlate?.value;
      vehicleLicensePlate && (finalObject.vehicle_license_plate = maskData(null, 3, vehicleLicensePlate));

      const towProvider = nested?.towProvider?.company?.value;
      towProvider && (finalObject.tow_provider = towProvider);
    }
    // Property
    if (typeOfClaim === 'Home') {
      const propertyContactedCleaning = boolToString(nested?.contactCleaningDamages?.value);
      propertyContactedCleaning && (finalObject.property_contacted_cleaning = propertyContactedCleaning);

      const propertyManagementCompany = claimData?.condo?.companyName?.value;
      propertyManagementCompany && (finalObject.property_management_company = propertyManagementCompany);

      const damageType = nested?.windHailDamage?.selectedValues || nested?.fireDamage?.selectedValues;
      damageType?.length > 0 && (finalObject.damage_type = damageType.join(', '));
    }
  }

  finalObject && Object.keys(finalObject).length && (finalObject.event = event);

  return finalObject;
}

function boolToString(value) {
  let stringVal = value;
  if (typeof value === 'boolean') {
    stringVal = value ? 'Yes' : 'No';
  }
  return stringVal;
}

function maskData(noOfStartMaskedChars, noOfEndMaskedChars, maskString) {
  const stringLength = maskString.length;
  let result;
  const star = '*';
  if (!noOfStartMaskedChars) {
    const visibleCharactersLength = maskString.slice(0, stringLength - noOfEndMaskedChars).length;
    result = star.repeat(visibleCharactersLength) + maskString.substring(stringLength - noOfEndMaskedChars, stringLength);
  } else {
    const maskedStringLength = maskString.substring(noOfStartMaskedChars, stringLength - noOfEndMaskedChars).length;
    result = maskString.substring(0, noOfStartMaskedChars) + star.repeat(maskedStringLength) + maskString.substring(stringLength - noOfEndMaskedChars, stringLength);
  }
  return result;
}
